import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardContent, CircularProgress, Container, Stack, TextField, Typography } from '@mui/material';

import { useToast } from '../../hooks/useToast';
import { useCreateSectionMutation } from '../../slices/apis/sectionApi';

export default function SectionNew() {
	const navigate = useNavigate();
	const [name, setName] = useState('');
	const [description, setDescription] = useState('');
	const { showToast, ToastElement } = useToast();
	const [createSection, { isLoading }] = useCreateSectionMutation();

	const handleSave = async () => {
		if (!name.trim()) {
			showToast('Name is required.', 'error');
			return;
		}

		try {
			const result = await createSection({ name, description: description || null }).unwrap();
			showToast('Section has been created successfully!', 'success');
			navigate(`/dashboard/admin/sections/${result.id}/edit`);
		} catch {
			showToast('Failed to save section. Please try again.', 'error');
		}
	};

	return (
		<>
			<Helmet>
				<title>New Section - {process.env.REACT_APP_ORG}</title>
			</Helmet>
			{ToastElement}
			<Container maxWidth="md" sx={{ mt: 4, mb: 8 }}>
				<Typography variant="h5" mb={3}>
					New Section
				</Typography>

				<Card variant="outlined">
					<CardContent>
						<Stack spacing={3}>
							<Stack spacing={2}>
								<TextField
									label="Name"
									variant="standard"
									required
									fullWidth
									value={name}
									onChange={(e) => setName(e.target.value)}
								/>
								<TextField
									label="Description"
									variant="standard"
									fullWidth
									multiline
									value={description}
									onChange={(e) => setDescription(e.target.value)}
								/>
							</Stack>

							<Stack direction="row" spacing={4}>
								<Button
									variant="outlined"
									color="primary"
									onClick={handleSave}
									disabled={isLoading}
									startIcon={isLoading ? <CircularProgress size={16} /> : null}
								>
									Save
								</Button>
								<Button color="error" variant="outlined" onClick={() => navigate('/dashboard/admin/sections')}>
									Cancel
								</Button>
							</Stack>
						</Stack>
					</CardContent>
				</Card>
			</Container>
		</>
	);
}
